export default {
  cardList: "Card List",
  deck: "Deck",
  news: "News",
  rules: "Rules",
  welcome: "Welcome",
};
